import React from 'react';

import { useIntl } from 'react-intl';

import Picture from 'components/picture';
import { useFeatureLayout } from 'hooks/use-feature-layout';

import { GiftCardImageContainer } from './styled';

const GiftCardImage: React.FC = () => {
  const { formatMessage } = useIntl();
  const { featureLayout } = useFeatureLayout();
  const giftCardImage = featureLayout?.giftCardImage?.locale;
  return (
    <GiftCardImageContainer>
      {giftCardImage && (
        <Picture image={giftCardImage} alt={formatMessage({ id: 'giftCard' })} objectFitContain />
      )}
    </GiftCardImageContainer>
  );
};

export default GiftCardImage;
